import { render, staticRenderFns } from "./CollectionBlackCust.vue?vue&type=template&id=7cdd4cea&scoped=true"
import script from "./CollectionBlackCust.vue?vue&type=script&lang=js"
export * from "./CollectionBlackCust.vue?vue&type=script&lang=js"
import style0 from "./CollectionBlackCust.vue?vue&type=style&index=0&id=7cdd4cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd4cea",
  null
  
)

export default component.exports